import { UseMutationResult } from "@tanstack/react-query";
import { trpc } from "lib/trpc";
import { ClientCurrentUser, UsersList } from "@compass/shared/types";

export const useUsers = (input: UsersList, currentUser?: ClientCurrentUser) => {
    const query = trpc.users.list.useQuery(input, {
        placeholderData: (prev) => prev,
        enabled: currentUser?.isCompassUser,
    });

    const { data, isInitialLoading } = query;
    const nothingFound = Boolean(
        !isInitialLoading && data && data.totalFound === 0 && Object.keys(input).length,
    );

    return { ...query, nothingFound };
};

export const useDeleteAvatarMutation = () => {
    const utils = trpc.useUtils();

    return trpc.users.deleteAvatar.useMutation({
        onSuccess: () => {
            utils.users.me.invalidate();
            utils.users.getPublic.invalidate();
            utils.users.get.invalidate();
        },
        onError: (error) => {
            console.error("Error deleting avatar:", error);
        },
    });
};
